// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"Notifier-module__buttonContainer___1jyLb","container":"Notifier-module__container___EWbJj","contentContainer":"Notifier-module__contentContainer___bvpR6"};